module.exports = __webpack_public_path__ + "img/vippack_cod_dg.6cd5c657.png";